import axios from "axios";

// this pushes whatever http library we use to the fringes of our app.
export default class Http{
    constructor(){
        this.http = axios.create({
        });
    }

    async GetAsync(url){
        let res = await this.http.get(url)
            .then((data) => data.data)
            .catch(() => null);
        return res;
    }

    async PostAsync(url, obj){
        let res = await this.http.post(url, obj)
            .then((data) => data.data)
            .catch(() => null);
        return res;
    }
}